import React from "react";
import { connect } from "react-redux";
import ConsolidatedBilling from "../components/members/ConsolidatedBilling";
import PropTypes from "prop-types";
import { getConsolidatedBilling } from "../actions/members";

const ConsolidatedBillingContainer = (props) => <ConsolidatedBilling {...props}/>;

const mapStateToProps = state => ({
  member: state.selectedMember,
  consolidatedBilling: state.consolidatedBilling,
});

const mapDispatchToProps = (dispatch) => ({
  doFetchGetConsolidatedBilling: (accountID) => {
     dispatch(getConsolidatedBilling(accountID));
   },
});

ConsolidatedBillingContainer.propTypes = {
  member: PropTypes.object,
  consolidatedBilling: PropTypes.array,
  doFetchGetConsolidatedBilling: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsolidatedBillingContainer);
